import React, { ReactNode } from 'react';
import { BankId } from '@tink/core/src/components/atoms/Icons/BankId';
import { Lock } from '@tink/core/src/components/atoms/Icons/Lock';
import { House } from '@tink/core/src/components/atoms/Icons/House';
import { Bank } from '@tink/core/src/components/atoms/Icons/Bank';
import { Verified } from '@tink/core/src/components/atoms/Icons/Verified';
import { IconBaseProps } from '@tink/core/src/components/atoms/Icons/IconBase';
import { Sizes } from 'styled-components';
import { Profile } from '@tink/core/src/components/atoms/Icons/Profile';
import { LockEmpty } from '@tink/core/src/components/atoms/Icons/LockEmpty';
import { Caption } from '../../atoms/Text/Text';
import { Divider } from './Divider';
import { Container, IconContainer, TextContainer } from './InformationField.styles';

export type InformationFieldProps = {
  iconVariant: 'bank-id' | 'lock' | 'lock-empty' | 'profile' | 'bank' | 'bank2' | 'verified';
  informationText?: string;
  children?: ReactNode;
  isDecorated?: boolean;
  iconColor?: 'primary' | 'text';
};

type Icons = Record<InformationFieldProps['iconVariant'], IconConfig>;

type IconConfig = {
  Icon: React.FC<IconBaseProps>;
  size: Sizes;
};

const icons: Icons = {
  'bank-id': {
    Icon: BankId,
    size: 'medium',
  },
  lock: {
    Icon: Lock,
    size: 'normedium',
  },
  'lock-empty': {
    Icon: LockEmpty,
    size: 'normedium',
  },
  profile: {
    Icon: Profile,
    size: 'normedium',
  },
  bank: {
    Icon: House,
    size: 'normedium',
  },
  bank2: {
    Icon: Bank,
    size: 'normedium',
  },
  verified: {
    Icon: Verified,
    size: 'normedium',
  },
};

export const InformationField: React.FC<InformationFieldProps> = ({
  iconVariant,
  informationText,
  children,
  isDecorated = true,
  iconColor = 'text',
}) => {
  const { Icon, size } = icons[iconVariant];

  return (
    <Container hasTintedBackground={isDecorated}>
      <IconContainer>
        <Icon
          color={iconColor === 'text' ? undefined : 'primary'}
          fontSize={size}
          data-testid={iconVariant}
        />
      </IconContainer>
      {isDecorated ? <Divider /> : null}
      <TextContainer>{children || <Caption>{informationText}</Caption>}</TextContainer>
    </Container>
  );
};
